export enum ErrorType {
    RecordNotFound = 'RecordNotFound',
    CXMException = 'CXMException',
    INTERNAL = 'INTERNAL'
}